// Three-tier performance detection: low / mid / high.
// Detection runs once at module load using navigator hints.

export function detectTier({ cores, memory, isMobile }) {
  if (isMobile) return "low";
  if (cores <= 4) return "low";
  if (memory !== undefined && memory <= 4) return "low";
  if (cores >= 12 && memory !== undefined && memory > 8) return "high";
  return "mid";
}

export function configForTier(tier) {
  switch (tier) {
    case "low":
      return {
        tier,
        grassInstances: 150000,
        bugCount: 30,
        rainCount: 20000,
        dpr: [1, 1],
        groundSegments: 12,
        starCount: 400,
        groundTextureSize: 512,
      };
    case "mid":
      return {
        tier,
        grassInstances: 600000,
        bugCount: 80,
        rainCount: 50000,
        dpr: [1, 1.2],
        groundSegments: 20,
        starCount: 800,
        groundTextureSize: 2048,
      };
    case "high":
    default:
      return {
        tier,
        grassInstances: 1200000,
        bugCount: 200,
        rainCount: 80000,
        dpr: [1, 1.5],
        groundSegments: 32,
        starCount: 1500,
        groundTextureSize: 2048,
      };
  }
}

const tier = (() => {
  if (typeof navigator === "undefined") return "mid";
  return detectTier({
    cores: navigator.hardwareConcurrency || 4,
    memory: navigator.deviceMemory,
    isMobile: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent),
  });
})();

export const PERF = {
  ...configForTier(tier),
  isLowEnd: tier === "low",
};
